import axios from "axios";
import configuration from "@/utils/configuration";

const consentModules = {
  namespaced: true,
  state: {
    agreeConsent: null,
  },
  loading: false,
  error: {},
  mutations: {
    setAgreeConSent(state, payload) {
      state.agreeConsent = payload;
    },
  },
  actions: {
    async getConsent({ commit }) {
      const { data } = await axios({
        method: "GET",
        url: `${configuration.backUrl}/user-consent`,
        withCredentials: true,
      });
      commit("setAgreeConSent", data?.data);
    },

    async sentConsent({ commit }, payload) {
      const { data } = await axios({
        method: "POST",
        url: `${configuration.backUrl}/user-consent`,
        withCredentials: true,
        data: payload,
      });
      commit("setAgreeConSent", data?.data);
      return data;
    },
  },
  getters: {
    consentStatus: (state) => state.agreeConsent,
  },
};

export default consentModules;

